import { styled, Toolbar } from '@mui/material'

const LoginToolbar = styled(Toolbar)(({ theme }) => ({
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    minHeight: 120,
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: 80,
  },
}))

export default LoginToolbar
